import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container text-center itens-center mb-10"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_4 = { class: "text-muted fs-3 fw-bold mt-5" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }

import CheckoutMain from "@/views/crafted/checkout/CheckoutMain.vue";
import SubscriptionMain from "@/views/crafted/subscription/SubscriptionMain.vue";
import {useStore} from "vuex";
import {Actions} from "@/store/enums/StoreEnums";
import {computed, onMounted, ref} from "vue";
import moment from "moment/moment";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();
let orders = ref([]);
const loading = ref(true)
const user = computed(() => store.getters.currentUser);
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
moment.locale('pt-br')

onMounted(async () => {
  try {
    await store.dispatch(Actions.VERIFY_AUTH);
  }catch (e) {
    console.error(e);
  }finally {
    if(!user.value.is_premium){
      await router.push({name: 'dashboard'})
    }
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, "   Hacking " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.in_progress`)) + "...", 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_unref(user).is_premium)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(CheckoutMain)
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})